module.exports = __webpack_public_path__ + "img/security.572e601f.svg";